import MapService from '../service/map'

export default {
  install: function (Vue, options) {
    Vue.prototype.$mapService = new MapService(options.map)
  }
}



// WEBPACK FOOTER //
// ./src/plugin/map.js